module.exports = __webpack_public_path__ + "img/bejelent.c9cad1c2.png";